module.exports = __webpack_public_path__ + "img/b.b8576dea.jpg";